(function () {
  'use strict';
  var cfgEl = document.getElementById('viwa-config');
  var cfg = {threshold: 12, amount: 6000, packValue: 9, pack: '', cans: [], tabs: [], img: {}};
  try { if (cfgEl) cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
  var cdlg = document.getElementById('cdlg');
  var toastEl = document.querySelector('[data-toast]');
  var toastTimer;

  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
    });
  }
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2200);
  }
  function bottles(item) {
    var h = item.handle;
    if (h === cfg.pack) return cfg.packValue * item.quantity;
    if (cfg.cans.indexOf(h) > -1 || (cfg.tabs || []).indexOf(h) > -1) return 0;
    return item.quantity;
  }
  function render(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    var lines = document.getElementById('lines');
    if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML = '<p class="empty">Votre panier est vide.</p>';
    } else {
      var rows = cart.items.map(function (it, i) {
        var src = cfg.img[it.handle] && cfg.img[it.handle].indexOf('p-.webp') < 0 ? cfg.img[it.handle] : (it.image || '');
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small><br>' : '';
        var subs = '';
        if (it.properties) {
          Object.keys(it.properties).forEach(function (k) {
            var v = it.properties[k]; if (!v) return;
            var im = (cfg.choices || {})[v];
            subs += '<div class="sub">' + (im ? '<img src="' + esc(im) + '" alt="" width="34" height="40">' : '<span class="noimg"></span>') +
              '<span><small>' + esc(k) + '</small><b>' + esc(v) + '</b></span>' + (/offerte/i.test(k) ? '<em class="free">Offerte</em>' : '') + '</div>';
          });
          if (subs) subs = '<div class="subs">' + subs + '</div>';
        }
        return '<div class="line"><img src="' + esc(src) + '" alt="" width="52" height="64">' +
          '<div><b>' + esc(it.product_title) + '</b>' + variant + '<small>' + money(it.final_price) + '</small></div>' +
          '<div class="qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Retirer un">−</button>' +
          '<output>' + it.quantity + '</output>' +
          '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button></div></div>' + subs;
      });
      var isCan = function (it) { return cfg.cans.indexOf(it.handle) > -1; };
      var isTab = function (it) { return (cfg.tabs || []).indexOf(it.handle) > -1; };
      var rb = [], rc = [], rt = [];
      cart.items.forEach(function (it, i) { (isTab(it) ? rt : isCan(it) ? rc : rb).push(rows[i]); });
      var groups = [rb, rc, rt].filter(function (g) { return g.length; }).map(function (g) { return g.join(''); });
      lines.innerHTML = groups.join('<hr class="sep" aria-hidden="true">');
    }
    var total = document.getElementById('total');
    if (total) total.textContent = money(cart.total_price);
    var n = cart.items.reduce(function (a, it) { return a + bottles(it); }, 0);
    var ship = document.getElementById('ship'), txt = document.getElementById('shiptxt'), bar = document.getElementById('shipbar');
    if (ship && txt && bar) {
      var amt = cfg.amount || 0, ok = n >= cfg.threshold || (amt > 0 && cart.total_price >= amt);
      ship.classList.toggle('ok', ok);
      bar.style.width = Math.min(100, Math.round(Math.max(n / cfg.threshold, amt ? cart.total_price / amt : 0) * 100)) + '%';
      txt.innerHTML = ok ? '<b>Félicitations, votre livraison est offerte !</b>'
        : 'Plus que <b>' + (cfg.threshold - n) + '</b> bouteille' + (cfg.threshold - n > 1 ? 's' : '') + (amt ? ' ou <b>' + money(Math.max(0, amt - cart.total_price)) + '</b>' : '') + ' pour la livraison offerte.';
      txt.innerHTML += '<small class="shipd">Bouteilles : <b>' + Math.min(n, cfg.threshold) + '/' + cfg.threshold + '</b>' + (amt ? ' &nbsp;·&nbsp; Panier : <b>' + money(Math.min(cart.total_price, amt)) + ' / ' + money(amt) + '</b>' : '') + '</small>';
    }
  }
  function refresh() {
    return fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
  }
  function openCart() {
    refresh();
    if (cdlg && typeof cdlg.showModal === 'function' && !cdlg.open) cdlg.showModal();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var oc = t.closest('[data-open-cart]');
    if (oc) { e.preventDefault(); openCart(); return; }
    var cg = t.closest('[data-cgv]');
    if (cg) { var d = document.getElementById('cgvdlg'); if (d && d.showModal) { d.showModal(); } return; }
    var cl = t.closest('[data-close]');
    if (cl) { var dl = cl.closest('dialog'); if (dl) dl.close(); return; }
    if (t.tagName === 'DIALOG' && t.open) { t.close(); return; }
    var q = t.closest('[data-line]');
    if (q) {
      fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({line: Number(q.dataset.line), quantity: Math.max(0, Number(q.dataset.q))})})
        .then(function (r) { return r.json(); }).then(render);
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('js-add')) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(f)})
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; }); })
      .then(function () { toast('Ajouté au panier'); openCart(); })
      .catch(function (err) { toast(err.message || 'Ajout impossible'); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  refresh();
})();
